import { EventParticipant } from 'domain/event/participants/EventParticipant';

export class EventBalance {
  constructor(
    public readonly waitingParticipantForCashout: EventParticipant[],
    public readonly readyParticipantForCashout: EventParticipant[],
  ) {}
}
